import {
    AfterContentInit,
    Component,
    ContentChildren,
    EventEmitter,
    Input,
    Output,
    QueryList,
} from '@angular/core';
import {TabComponent} from '@shared/tab/tab.component';

export interface IEventTabSelect {
    tab: TabComponent;
    index: number;
}

@Component({
    selector: 'app-tabs',
    templateUrl: './tabs.component.html',
    styleUrls: ['./tabs.component.scss']
})
export class TabsComponent implements AfterContentInit {
    @ContentChildren(TabComponent) tabs: QueryList<TabComponent>;
    @Output() eventTabSelect: EventEmitter<IEventTabSelect> = new EventEmitter();
    @Input() tabActiveIndex = 0;

    public ngAfterContentInit(): void
    {
        const activeTab = this.tabs.find((tab) => tab.active);

        if (!activeTab) {
            const activeTabByIndex = this.tabs.toArray()[this.tabActiveIndex];
            this.selectTab(activeTabByIndex, this.tabActiveIndex);
        }
    }

    public selectTab(tabSelected: TabComponent, index: number): void
    {
        this.eventTabSelect.emit({ tab: tabSelected, index });
        this.tabs.toArray().forEach(tab => tab.active = false);
        tabSelected.active = true;
    }
}
